// import React, { useEffect } from "react";
// import useForm from "../../../hooks/useForm";
// import useMutation from "../../../hooks/useMutation";
// import Button from "../../../components/form/Button";
// import Input from "../../../components/form/Input";
// import FileUploadSingle from "../../../components/form/FileUploadSingle";
// import * as Yup from "yup";

// import Select from "../../../components/form/Select";
// import { emailTemplateAddEdit } from "../../../services/emailService";
// import Editor from "../../../components/form/Editor";
// const SUPPORTED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];

// const validation = Yup.object().shape({
//   fromName: Yup.string().required("From Name is required"),
//   subject: Yup.string().required("Subject is required"),
//   content: Yup.string().required("Content is required"),
// });

// function ManageEmails({ getResponse = () => {}, close = () => {}, data }) {
//   const {
//     values,
//     handleChange,
//     handleSubmit,
//     errors,
//     setFieldsValue,
//     resetField,
//     formValidate,
//   } = useForm({
//     validationSchema: validation,
//     initialState: {
//       fromName: "",
//       subject: "",
//       content: "",
//     },
//   });

//   const {
//     mutate,
//     error,
//     isPending: isLoading,
//   } = useMutation({
//     mutationFn: async (val) => {
//       const { fromName, subject, content, ...rest } = val;
//       return await emailTemplateAddEdit({
//         id: data?._id,
//         ...val,
//       });
//     },
//     onSuccess: (res) => {
//       if (res.success) {
//         resetField();
//         if (res.success) {
//           // Reset form values
//           resetField();

//           // Assuming the updated item is in `res?.data`
//           const updatedItem = res?.data;

//           // Now update the list, only replacing the updated item
//           getResponse((prevData) => {
//             return prevData.map((item) =>
//               item._id === updatedItem._id ? updatedItem : item
//             );
//           });
//         }
//       }
//       getResponse(res);
//       return res;
//     },
//     onError: (error) => {
//       console.log(error);
//     },
//   });

//   useEffect(() => {
//     if (data?._id) {
//       setFieldsValue(data);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [data]);

//   return (
//     <form onSubmit={(e) => handleSubmit(e, mutate)}>
//       <div className="relative col-span-2">
//         <Input
//           label="From Name"
//           inputPlaceholder="Enter From Name"
//           inputName="fromName"
//           value={values?.fromName}
//           onChange={handleChange}
//           errorText={errors.fromName}
//         />
//       </div>

//       <div className="relative col-span-2">
//         <Input
//           label="Subject"
//           inputPlaceholder="Enter Subject"
//           inputName="subject"
//           value={values?.subject}
//           onChange={handleChange}
//           errorText={errors.subject}
//         />
//       </div>

//       <label className="text-xs font-medium text-shades-07">HTML Content</label>

//       <Editor
//         placeholder="Enter HTML content"
//         value={values?.content}
//         onChange={(val) =>
//           handleChange({
//             target: { name: "content", value: val },
//           })
//         }
//       />

//       {/* Submit & Cancel Buttons */}
//       <div className="relative col-span-4 mt-5">
//         <div className="flex items-center justify-center gap-4">
//           <Button
//             buttonType="submit"
//             buttonLabel={data?._id ? "Update Email" : "Add Email"}
//             buttonClasses="!rounded-full !px-8 !h-12 !border !bg-hobby !text-white"
//             buttonLabelClasses="mx-auto"
//             {...(isLoading && {
//               loading: true,
//               buttonIconPosition: "left",
//               isDisable: true,
//             })}
//           />
//           <Button
//             buttonLabel="Cancel"
//             buttonClasses="!rounded-full !px-8 !h-12 !border-2 !border-hobby !text-slate-800 !bg-transparent"
//             buttonLabelClasses="mx-auto"
//             buttonFunction={close}
//           />
//         </div>
//       </div>
//     </form>
//   );
// }

// export default ManageEmails;
import React, { useEffect } from "react";
import useForm from "../../../hooks/useForm";
import useMutation from "../../../hooks/useMutation";
import Button from "../../../components/form/Button";
import Input from "../../../components/form/Input";
import * as Yup from "yup";
import { emailTemplateAddEdit } from "../../../services/emailService";
import Editor from "../../../components/form/Editor";

const validation = Yup.object().shape({
  fromName: Yup.string().required("From Name is required"),
  subject: Yup.string().required("Subject is required"),
  content: Yup.string().required("Content is required"),
});

function ManageEmails({ getResponse = () => {}, close = () => {}, data }) {
  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationSchema: validation,
    initialState: {
      fromName: "",
      subject: "",
      content: "",
    },
  });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      const { content, ...rest } = val;
      return await emailTemplateAddEdit(
        data?._id
          ? { id: data?._id, ...rest } // Update existing template
          : { ...val } // Create new template
      );
    },
    onSuccess: (res) => {
      if (res.success) {
        resetField();
      }
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    if (data?._id) {
      // Prefill the form only if _id exists
      setFieldsValue({
        fromName: data?.fromName || "",
        subject: data?.subject || "",
        content: data?.content || "",
      });
    }
  }, [data]);

  return (
    <form onSubmit={(e) => handleSubmit(e, mutate)}>
      <div className="grid grid-cols-4 gap-x-4 gap-y-4">
        <div className="relative col-span-2">
          <Input
            label="From Name"
            inputPlaceholder="Enter From Name"
            inputName="fromName"
            value={values?.fromName}
            onChange={handleChange}
            {...formValidate(errors, "fromName")}
          />
        </div>

        <div className="relative col-span-2">
          <Input
            label="Subject"
            inputPlaceholder="Enter Subject"
            inputName="subject"
            value={values?.subject}
            onChange={handleChange}
            errorText={errors.subject}
          />
        </div>

        <div className="relative col-span-4">
          <label className="text-xs font-medium text-shades-07">
            HTML Content
          </label>
          <Editor
            placeholder="Enter HTML content"
            value={values?.content}
            onChange={(val) =>
              handleChange({
                target: { name: "content", value: val },
              })
            }
            errorText={errors.content}
          />
        </div>
      </div>

      {/* Submit & Cancel Buttons */}
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={data?._id ? "Update Email" : "Add Email"}
            buttonClasses="!rounded-full !px-8 !h-12 !border !bg-hobby !text-white"
            buttonLabelClasses="mx-auto"
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel="Cancel"
            buttonClasses="!rounded-full !px-8 !h-12 !border-2 !border-hobby !text-slate-800 !bg-transparent"
            buttonLabelClasses="mx-auto"
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
}

export default ManageEmails;
